import * as React from 'react'
import { CaretLeft, X } from '@phosphor-icons/react'

type CreateNewSkillViewProps = {
  onBack: () => void
  onClose: () => void
  onCreateSkill: (skillName: string) => void
}

export const CreateNewSkillView: React.FC<CreateNewSkillViewProps> = ({
  onBack,
  onClose,
  onCreateSkill,
}) => {
  const [skillName, setSkillName] = React.useState('')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (skillName.trim()) {
      onCreateSkill(skillName.trim())
    }
  }

  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
        <div className="flex items-center gap-2">
          <button
            onClick={onBack}
            className="p-1 rounded hover:bg-gray-100 text-gray-500"
          >
            <CaretLeft className="h-5 w-5" weight="bold" />
          </button>
          <h2 className="text-lg font-semibold text-gray-900">
            Create new personal skill
          </h2>
        </div>
        <button
          onClick={onClose}
          className="p-2 rounded-full hover:bg-gray-100 text-gray-500"
        >
          <X className="h-5 w-5" />
        </button>
      </div>

      <form onSubmit={handleSubmit} className="flex-1 p-6">
        <div className="mb-6">
          <label
            htmlFor="skill-name"
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            Skill name
          </label>
          <input
            id="skill-name"
            type="text"
            value={skillName}
            onChange={(e) => setSkillName(e.target.value)}
            placeholder=""
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent"
            autoFocus
          />
        </div>

        <button
          type="submit"
          disabled={!skillName.trim()}
          className="w-full py-2.5 bg-gray-900 text-white text-sm font-medium rounded-lg hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Create skill
        </button>
      </form>
    </div>
  )
}
